import React, { useState, useEffect } from "react";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import "./Header.css";

const Header = () => {
  const [showTop, setShowTop] = useState(true);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      scrollPosition > 300 ? setShowTop(false) : setShowTop(true);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="App" id="home">
      <Navbar
        expand="xl"
        className={
          showTop ? "strefa-navbar-blue" : "strefa-navbar-white fixed-top"
        }
      >
        <Container>
          <Navbar.Brand href="/">StrefaDlaEdukacji.pl</Navbar.Brand>
          {!showMenu && (
            <Navbar.Toggle
              className="custom-toggler"
              onClick={() => setShowMenu(true)}
              aria-controls="offcanvas-menu"
            >
              <div></div>
            </Navbar.Toggle>
          )}
          <Navbar.Collapse id="basic-navbar-nav" className="d-none d-xl-flex">
            <Nav className="justify-content-end">
              <Nav.Link href="/">Strona główna</Nav.Link>
              <Nav.Link href="/offer">Oferta</Nav.Link>
              <Nav.Link href="/pricing">Cennik</Nav.Link>
              <Nav.Link href="/about">O nas</Nav.Link>
              <Nav.Link href="/contact">Kontakt</Nav.Link>
              <Nav.Link
                href="https://backend.strefadlaedukacji.pl/register/"
                className="menu-button"
              >
                Załóż konto
              </Nav.Link>
              <Nav.Link
                href="https://backend.strefadlaedukacji.pl/login/"
                className="menu-button"
              >
                Zaloguj się
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Offcanvas
        show={showMenu}
        onHide={() => setShowMenu(false)}
        placement="start"
        id="offcanvas-menu"
        className="offcanvas-menu-custom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="offcanvas-title-custom">
            StrefaDlaEdukacji.pl
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column offcanvas-body-custom">
            <Nav.Link href="/" onClick={() => setShowMenu(false)}>
              Strona główna
            </Nav.Link>
            <Nav.Link href="/offer" onClick={() => setShowMenu(false)}>
              Oferta
            </Nav.Link>
            <Nav.Link href="/pricing" onClick={() => setShowMenu(false)}>
              Cennik
            </Nav.Link>
            <Nav.Link href="/about" onClick={() => setShowMenu(false)}>
              O nas
            </Nav.Link>
            <Nav.Link href="/contact" onClick={() => setShowMenu(false)}>
              Kontakt
            </Nav.Link>
            <Nav.Link
              href="https://backend.strefadlaedukacji.pl/register/"
              onClick={() => setShowMenu(false)}
              className="menu-button"
            >
              Załóż konto
            </Nav.Link>
            <Nav.Link
              href="https://backend.strefadlaedukacji.pl/login/"
              onClick={() => setShowMenu(false)}
              className="menu-button"
            >
              Zaloguj się
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Header;
